import { Close } from "@mui/icons-material";
import { Box, ButtonBase, CircularProgress } from "@mui/material";
import React, { useCallback, useEffect, useRef, useState } from "react";
import OutputVideo from "../../Components/Shared/OutputVideo";
import VideoDetails from "./VideoDetails";
import { VideoModalData } from "../../../../Types/VideoSuite-Types";
import { useGetVideoSuiteHistoryById } from "../../../../store/Apis/SuitesApps/VideoSuiteHistoryApi";
import { useRegenerateVideo } from "../../../../store/Apis/SuitesApps/VideoSuiteApi";
import SignalRService from "../../../one-query/services/SignalRService";
import { MessageType, VideoSuiteApps } from "../../../../Helper";
import ImageToVideoIcon from "../../../../Custom-imeges/VideoSuite/ImageToVideoIcon";
import { AvatarVideoIcon } from "../../../../Custom-imeges/VideoSuite/AvatarVideoIcon";
import VideoGeneratorIcon from "../../../../Custom-imeges/VideoSuite/VideoGeneratorIcon";
import { VideoDetailsView } from "../../Components/Shared/VideoSuiteHelper";
import { useNavigate } from "react-router-dom";
import { videoLibraryItem } from "../../../InspirationLibrary/InspirationLibraryHelper";
const containerStyle = {
  py: 1.5,
  px: 2.5,
  display: "flex",
  flexDirection: "column",
  width: "80%",
  height: "80%",
  position: "absolute",
  borderRadius: "24px",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "#2A2C33",
};
const sharedDetailsContainerStyle = {
  display: "flex",
  flexDirection: "column",
  flex: 1,
  px: 2,
  py: 1,
  borderRadius: "12px",
};

export const getVideoSuiteHistoryAppIcon = (appType: String) => {
  switch (appType) {
    case VideoSuiteApps.VideoGenerator:
      return <VideoGeneratorIcon className="text-nav-item-icon" />;
    case VideoSuiteApps.ImageToVideo:
      return <ImageToVideoIcon className="text-nav-item-icon" />;
    case VideoSuiteApps.CustomAvatar:
      return <AvatarVideoIcon className="text-nav-item-icon" />;
    default:
      return null;
  }
};

interface VideoSuiteHistoryDetailsModalProps {
  videoId: string;
  handleCloseModal: () => void;
  setIsFireRegenerate: (value: boolean) => void;
  view?: number;
  btnActionText: string;
  videoLibraryData?: videoLibraryItem | null;
}
const VideoSuiteHistoryDetailsModal = ({
  videoId,
  handleCloseModal,
  setIsFireRegenerate,
  view = VideoDetailsView.history,
  btnActionText,
  videoLibraryData,
}: VideoSuiteHistoryDetailsModalProps) => {
  const historyVideoRef = useRef<HTMLVideoElement | null>(null)
  const navigate = useNavigate();
  const [currentVideoId, setCurrentVideoId] = useState<string>("");
  const [isRegenerateLoading, setIsRegenerateLoading] =
    useState<boolean>(false);
  const [videoRegenerateLink, setVideoRegenerateLink] = useState<string>();
  const { data: videoHistoryData, isLoading } =
    useGetVideoSuiteHistoryById(currentVideoId);
  const { mutate: regenerateVideo } = useRegenerateVideo();
  const [currentVideoData, setCurrentVideoData] = useState<VideoModalData>({
    id: "",
    createdAt: "",
    input: { prompt: "", attachment: "" },
    output: "",
    appType: "",
    settings: {
      model: "",
      dimension: "",
      style: "",
      videoQuality: "",
      duration: "",
      seed: 0,
    },
  });

  useEffect(() => {
    if (view !== VideoDetailsView.library) {
      setCurrentVideoId(videoId);
    }
  }, [videoId]);

  useEffect(() => {
    if (videoHistoryData && view !== VideoDetailsView.library) {
      setCurrentVideoData(videoHistoryData);
    } else if (VideoSuiteApps) {
      const videoData = {
        id: "",
        appType: VideoSuiteApps.VideoGenerator,
        input: {
          prompt: videoLibraryData?.prompt || "",
          attachment: null,
        },
        output: videoLibraryData?.url || "",
        settings: {
          model: "Flux",
          dimension: "1:1",
          style: "No Style",
          videoQuality: "720p",
          duration: "5",
          seed: null,
        },
        createdAt: "2025-06-23T10:31:56.114942Z",
      };
      setCurrentVideoData(videoData);
    }
  }, [videoHistoryData, VideoSuiteApps]);

  const handleRegenerateVideo = async () => {
    if (view === VideoDetailsView.history) {
      setIsRegenerateLoading(true);
      const connectionId = await SignalRService.getInstance().getConnectionId();
      const data = {
        historyId: videoId,
        connectionId: connectionId,
      };
      regenerateVideo(data);
    } else if (view === VideoDetailsView.library) {
      navigate("/suites/video-suite", {
        state: {
          activeVideoAppData: currentVideoData,
          activeVideoAppType: currentVideoData?.appType,
        },
      });
    }
  };

  const handleGenerateVideoSuitesSignalR = useCallback(
    (message: string, messageType: number) => {
      if (message === "**/**Finished**/**") {
        setIsRegenerateLoading(false);
        setIsFireRegenerate(true);
      } else {
        if (messageType === MessageType.VideoSuitesGenerateVideo) {
          setVideoRegenerateLink(message);
        } else if (messageType === MessageType.VideoSuitesImageToVideo) {
          setVideoRegenerateLink(message);
        }
      }
    },
    []
  );
  const setupSignalRConnection = useCallback(() => {
    const connection = SignalRService.getInstance().connection;
    connection.on("SendVideoMessage", handleGenerateVideoSuitesSignalR);
    return () => {
      connection.off("SendVideoMessage", handleGenerateVideoSuitesSignalR);
    };
  }, [handleGenerateVideoSuitesSignalR]);
  useEffect(() => {
    const cleanup = setupSignalRConnection();
    return () => {
      cleanup();
    };
  }, [setupSignalRConnection]);
  return (
    <Box
      sx={{ ...containerStyle }}
      className="video-suite-history-details-modal"
    >
      {/* close icon */}
      <Box
        className="video-suite-history-details-modal-close-icon"
        sx={{
          mb: 1,
          display: "flex",
          justifyContent: "flex-end",
          width: 1,
        }}
      >
        <ButtonBase onClick={handleCloseModal}>
          <Close
            sx={{
              fontSize: "24px",
            }}
          />
        </ButtonBase>
      </Box>
      {isLoading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexGrow: 1,
          }}
        >
          <CircularProgress size={50} color="primary" />
        </Box>
      ) : (
        currentVideoData && (
          <Box
            sx={{
              p: 1,
              display: "flex",
              flexDirection: { xs: "column-reverse", md: "row" },
              overflow: "hidden",
              flexGrow: 1,
              gap: 2,
              width: 1,
              height: 1,
            }}
          >
            {/* video */}
            <Box
              className="video-details-container video-out-container "
              sx={{
                ...sharedDetailsContainerStyle,
                height: { xs: "50%", md: "100%" },
                width: "100%",
              }}
            >
                <OutputVideo
                ref={historyVideoRef}
                isHistory
                isLoading={isRegenerateLoading}
                generateTime="1"
                videoUrl={
                  videoRegenerateLink
                    ? videoRegenerateLink
                    : currentVideoData.output
                }
              />
            </Box>
            {/* data */}
            <Box
              className="video-details-container"
              sx={{
                ...sharedDetailsContainerStyle,
                overflow: "hidden",
                height: { xs: "50%", md: "100%" },
              }}
            >
              <VideoDetails
                videoDetailsData={currentVideoData}
                handleRegenerateVideo={handleRegenerateVideo}
                isRegenerateLoading={isRegenerateLoading}
                btnActionText={btnActionText}
              />
            </Box>
          </Box>
        )
      )}
    </Box>
  );
};

export default VideoSuiteHistoryDetailsModal;
